import React from 'react';
import styled from 'styled-components';
import { Type, screenXlMin, screenSmMax, screenXxsMax, screenMdMin, screenXsMin, } from '@spotify-internal/encore-web';
const HeadlineXlDesktop = styled(Type) `
  display: block;
  @media (max-width: ${screenXlMin}) {
    display: none;
  }
`;
const HeadlineLgDesktop = styled(Type) `
  display: none;
  @media (min-width: 1440px) and (max-width: ${screenXlMin}) {
    display: block;
  }
`;
const HeadlineMdDesktop = styled(Type) `
  display: none;
  @media (min-width: 1200px) and (max-width: 1439px) {
    display: block;
  }
`;
const HeadlineDesktop = styled(Type) `
  display: none;
  @media (min-width: ${screenMdMin}) and (max-width: 1199px) {
    display: block;
  }
`;
const HeadlineMobile = styled(Type) `
  display: none;
  @media (max-width: ${screenSmMax}) and (min-width: ${screenXsMin}) {
    display: block;
    .hero-headline {
      padding-top: 32px;
    }
  }
`;
const HeadlineSmMobile = styled(Type) `
  display: none;
  @media (max-width: ${screenXxsMax}) {
    display: block;
    .hero-headline {
      padding-top: 32px;
    }
  }
`;
export const JumpLinkResponsiveEncoreType = ({ as, variantXlDesktop, variantLgDesktop, variantMdDesktop, variantDesktop, variantMobile, variantSmMobile, className, children, }) => {
    return (React.createElement("div", { className: className },
        React.createElement(HeadlineXlDesktop, { as: as, variant: variantXlDesktop }, children),
        React.createElement(HeadlineLgDesktop, { as: as, variant: variantLgDesktop }, children),
        React.createElement(HeadlineMdDesktop, { as: as, variant: variantMdDesktop }, children),
        React.createElement(HeadlineDesktop, { as: as, variant: variantDesktop }, children),
        React.createElement(HeadlineMobile, { as: as, variant: variantMobile }, children),
        React.createElement(HeadlineSmMobile, { as: as, variant: variantSmMobile }, children)));
};
//# sourceMappingURL=JumpLinkResponsiveEncoreType.js.map